// TODO: type properly
export let SortDirection;

(function (SortDirection) {
  SortDirection["Ascending"] = "Ascending";
  SortDirection["Descending"] = "Descending";
  SortDirection["None"] = "None";
})(SortDirection || (SortDirection = {}));